import JerseyColorSelectorModal, { JERSEY_COLOR_SELECTOR_MODAL } from './modal';

export { JERSEY_COLOR_SELECTOR_MODAL };

export default JerseyColorSelectorModal;
